import { formatUnitValue } from "../unitWiseCostFilterOptions";
import { generateUnitColors } from "./unitWiseCostDoughnutChart";

export const unitWiseCostValueLabelPlugin = (valueMode) => ({
    id: "unitWiseCostValueLabel",

    afterDatasetsDraw(chart) {
        const { ctx } = chart;

        const dataset = chart.data.datasets[0];
        const meta = chart.getDatasetMeta(0);

        if (!dataset || !meta) return;

        ctx.save();

        ctx.font = "600 11px Arial";
        ctx.textAlign = "left";
        ctx.textBaseline = "middle";
        ctx.fillStyle = "#344054";

        meta.data.forEach((bar, index) => {
            const value = Number(dataset.data[index]);

            if (!Number.isFinite(value)) return;

            ctx.fillText(
                formatUnitValue(value, valueMode),
                bar.x + 8,
                bar.y
            );
        });

        ctx.restore();
    },
});

export const getUnitWiseCostChartData = (sortedUnitData = []) => ({
    labels: sortedUnitData.map((item) => item.unitName),

    datasets: [
        {
            label: "Cost %",
            data: sortedUnitData.map((item) => item.value),

            // backgroundColor: (context) => {
            //     const { chart, dataIndex } = context;
            //     const { ctx, chartArea } = chart;

            //     if (!chartArea) {
            //         return "#155EEF";
            //     }

            //     const gradients = [
            //         ["#60A5FA", "#2563EB"], // blue
            //         ["#6EE7B7", "#10B981"], // green
            //         ["#FCD34D", "#F59E0B"], // amber
            //         ["#C4B5FD", "#8B5CF6"], // purple
            //         ["#FDA4AF", "#F43F5E"], // rose
            //         ["#67E8F9", "#06B6D4"], // cyan
            //     ];

            //     const colors =
            //         gradients[dataIndex % gradients.length];

            //     const gradient = ctx.createLinearGradient(
            //         chartArea.left,
            //         0,
            //         chartArea.right,
            //         0
            //     );

            //     gradient.addColorStop(0, colors[0]);
            //     gradient.addColorStop(1, colors[1]);

            //     return gradient;
            // },

            backgroundColor: (context) => {
                const { chart, dataIndex } = context;
                const { chartArea } = chart;

                if (!chartArea) {
                    return "#155EEF";
                }

                // one distinct hue per bar - scales cleanly to 40+ units,
                // unlike the old fixed 6-gradient palette that repeated.
                const colors = generateUnitColors(sortedUnitData.length);

                return colors[dataIndex];
            },
            borderWidth: 0,

            // Pill-shaped bars
            // borderRadius: 999,
            borderRadius: {
                topLeft: 0,
                bottomLeft: 0,
                topRight: 10,
                bottomRight: 10,
            },
            borderSkipped: false,

            barThickness: 22,
            maxBarThickness: 22,
        },
    ],
});


export const getUnitWiseCostChartOptions = (valueMode) => ({
    responsive: true,
    maintainAspectRatio: false,

    indexAxis: "y",

    plugins: {

        legend: {
            display: false,
        },

        tooltip: {
            callbacks: {
                label: (context) => {
                    return formatUnitValue(context.raw, valueMode);
                },
            },
        },
    },

    scales: {
        x: {
            beginAtZero: true,
            grace: "15%",
            title: {
                display: true,
                text: valueMode === "CRORE" ? "Value (₹ Cr)" : "Percentage (%)",
            },

            ticks: {
                callback: (value) => formatUnitValue(value, valueMode),
            },

            grid: {
                color: "rgba(16, 24, 40, 0.06)",
            },
        },

        y: {
            ticks: {
                autoSkip: false,

                font: {
                    size: 12,
                },
            },

            grid: {
                display: false,
            },
        },
    },
});


export const getUnitWiseCostChartHeight = (dataLength) => {
    return Math.max(400, dataLength * 45);
};